function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, isMenuOpen, windowErrorMsg) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-bucket-selector': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`label`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-bucket-selector-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($attr(`label`));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("mp-select", {
          "attrs": {
            'icon': JSON.stringify({
              leftIcon: `expand`
            }),
            'theme': `builder`,
            'open': isMenuOpen,
            'selected-option': $helpers.getDisplayedBucketLabel(),
          },
          "on": {
            menuChange: $helpers.changeMenu
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": {
              'slot': `body`
            },
            "class": {
              'mp-bucket-selector-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((isMenuOpen) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-drop-menu-pane", {
                "attrs": {
                  header: 'Select an Interval',
                  'show-back-button': false
                },
                "style": {
                  'overflow': `visible`
                },
                "class": {
                  'mp-bucket-selector-menu': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-bucket-selector-menu-content': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-bucket-selector-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-bucket-selector-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("INTERVAL");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-bucket-selector-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("input", {
                      "attrs": {
                        type: `number`
                      },
                      "on": {
                        input: $helpers.changeBucketSize,
                        keyup: $helpers.handleKeyUp,
                      },
                      "props": {
                        value: $helpers.getBucketSize(),
                      },
                      "hook": {
                        insert: $helpers.inputInserted
                      },
                      "class": Object.assign({}, {
                        error: !!windowErrorMsg
                      }, {
                        'mp-bucket-selector-value-input': true
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat((!$helpers.showDropDown()) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-bucket-selector-unit-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat($attr(`selected-unit`));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-select", {
                        "attrs": {
                          sections: JSON.stringify($helpers.getBucketUnits()),
                        },
                        "on": {
                          change: $helpers.changeBucketUnit
                        },
                        "class": {
                          'mp-bucket-selector-unit-selector': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-bucket-selector-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-bucket-selector-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("MINIMUM");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-bucket-selector-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("input", {
                      "attrs": {
                        type: `number`
                      },
                      "on": {
                        input: $helpers.changeBucketMin,
                        keyup: $helpers.handleKeyUp,
                      },
                      "props": {
                        value: $helpers.getMin()
                      },
                      "class": Object.assign({}, {
                        error: !!windowErrorMsg
                      }, {
                        'mp-bucket-selector-value-input': true
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-bucket-selector-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-bucket-selector-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("MAXIMUM");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-bucket-selector-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("input", {
                      "attrs": {
                        type: `number`
                      },
                      "on": {
                        input: $helpers.changeBucketMax,
                        keyup: $helpers.handleKeyUp,
                      },
                      "props": {
                        value: $helpers.getMax()
                      },
                      "class": Object.assign({}, {
                        error: !!windowErrorMsg
                      }, {
                        'mp-bucket-selector-value-input': true
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(($attr(`reset-bucket`)) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-bucket-selector-row': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": {
                          size: 'small',
                        },
                        "on": {
                          click: $helpers.resetInterval
                        },
                        "class": {
                          'mp-button-secondary': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Reset interval");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat((windowErrorMsg) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": {
                      'always-show': true,
                      'hide-arrow': true,
                      type: `error`,
                    },
                    "class": {
                      'mp-bucket-selector-error-tooltip': true
                    },
                  }, [__vjadeSafeCode(windowErrorMsg)]));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                "attrs": {
                  'disabled': !!windowErrorMsg,
                  'tabindex': 0,
                },
                "on": {
                  click: $helpers.applyBucketSelections
                },
                "class": {
                  'mp-button-bar-primary': true,
                  'mp-bucket-selector-submit-btn': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Apply");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "isMenuOpen" in locals ? locals.isMenuOpen : typeof isMenuOpen !== "undefined" ? isMenuOpen : undefined, "windowErrorMsg" in locals ? locals.windowErrorMsg : typeof windowErrorMsg !== "undefined" ? windowErrorMsg : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;